"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';

var DropdownCategoryType = /* @__PURE__ */ ((DropdownCategoryType2) => {
  DropdownCategoryType2["ROOT"] = "root";
  DropdownCategoryType2["VARIABLE"] = "variable";
  DropdownCategoryType2["OPTIONS"] = "options";
  DropdownCategoryType2["FORMULA"] = "formula";
  DropdownCategoryType2["FORMULA_CONFIG"] = "formula_config";
  DropdownCategoryType2["CUSTOM"] = "custom";
  DropdownCategoryType2["LOOKUP_OPTIONS"] = "lookup_options";
  DropdownCategoryType2["SELECT_FROM_UDM_DYNAMICALLY"] = "select_from_udm_dynamically";
  return DropdownCategoryType2;
})(DropdownCategoryType || {});
const dropdownCategoryConfig = {
  ["root" /* ROOT */]: {
    title: "Root",
    hideSearchInput: false
  },
  ["custom" /* CUSTOM */]: {
    title: "Custom Value",
    icon: SvgIconType.SchemaType_object,
    hideSearchInput: true
  },
  ["variable" /* VARIABLE */]: {
    title: "Variables",
    icon: SvgIconType.Variable
  },
  ["options" /* OPTIONS */]: {
    title: "Option"
  },
  ["formula" /* FORMULA */]: {
    title: "Formulas",
    icon: SvgIconType.Function,
    hideSearchInput: false
  },
  ["formula_config" /* FORMULA_CONFIG */]: {
    title: "Formulas",
    icon: SvgIconType.Function,
    hideSearchInput: true
  },
  ["lookup_options" /* LOOKUP_OPTIONS */]: {
    title: "Lookup Options",
    hideSearchInput: false
  },
  ["select_from_udm_dynamically" /* SELECT_FROM_UDM_DYNAMICALLY */]: {
    title: "Select Dynamically",
    hideSearchInput: true,
    hasConfigUI: true,
    icon: SvgIconType.Search
  }
};

export { DropdownCategoryType, dropdownCategoryConfig };
